// extracted by mini-css-extract-plugin
export default {"root":"XiCQ1G6mzw","actions":"vWkBI55VuM"};